import React, { Component } from 'react';

import UrbioticaParkinglocationsSelect from './UrbioticaParkinglocationsSelect';

import { Form, Input, Button, Modal, InputNumber, Select } from 'antd';
const FormItem = Form.Item;
const { Option } = Select;
class UrbioticaInfrastructuresForm extends Component {

  state = {
    modalVisible: false,
    disabled: true
  }

  form = null;

  componentWillReceiveProps(nextProps) {
    this.setState({
      modalVisible: nextProps.modalVisible
    });
  }

  handleTypeChange = e => {
    if (e == 'U-Spot') {
      this.setState({
        disabled: false
      });
    } else {
      this.setState({
        disabled: true
      });
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.props.onSuccess(this.props.form, values);
        this.props.onModalCancel(this.props.form);
      }
    });
  }

  renderForm() {
    const { disabled } = this.state;
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };

    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    return (
      <Form onSubmit={this.handleSubmit} ref={ref => { this.form = ref }}>
        <FormItem
          {...formItemLayout}
          label="Lokalita">
          {getFieldDecorator('parkingLocationID', {
            rules: [{
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <UrbioticaParkinglocationsSelect onChange={(value) => { this.props.form.setFieldsValue({ parkingLocationID: value }); }} />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="POM">
          {getFieldDecorator('pom', {
            rules: [{
              type: 'number', message: 'Položka musí být number!',
            }, {
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <InputNumber />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="ElementID">
          {getFieldDecorator('elementID', {
            rules: [{
              type: 'string', message: 'Položka musí být string!',
            }],
          })(
            <Input />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Typ">
          {getFieldDecorator('productType', {
            rules: [{
              required: true, message: 'Vyplňte prosím tuto položku!'
            }],
          })(
            <Select
              size="default"
              placeholder='Zvolte typ'
              onChange={this.handleTypeChange}
            >
              <Option value="U-Spot">U-Spot</Option>
              <Option value="U-Flow">U-Flow</Option>
              <Option value="U-Box">U-Box</Option>
            </Select>
          )}

        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Místo" >
          {getFieldDecorator('placeID', { initialValue: 0 },
            {
            })(
              <InputNumber min={0} max={999999} initialValue={0} disabled={disabled} />
            )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Typ zprávy">
          {getFieldDecorator('messageType', { initialValue: '--' }, {
            rules: [{
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <Select
              size="default"
              disabled={disabled}
            >
              <Option value="--">--</Option>
              <Option value="vehicle_ctrl">vehicle_ctrl</Option>
              <Option value="vehicle">vehicle</Option>
            </Select>
          )}
        </FormItem>
        <FormItem {...tailFormItemLayout}>
          <Button type="primary" htmlType="submit">Vložit</Button>
        </FormItem>
      </Form>
    );
  }

  render() {
    if (this.props.type && this.props.type === 'modal') {
      return (
        <Modal
          width={650}
          title="Vytvoření nové infrastruktury"
          visible={this.state.modalVisible}
          onCancel={() => {
            this.props.onModalCancel(this.props.form);
            this.setState({ modalVisible: false });
          }}
          footer={<p></p>}>
          {this.renderForm()}
        </Modal>
      )
    } else {
      return this.renderForm();
    }
  }
}

const WrappedInfrastructuresForm = Form.create()(UrbioticaInfrastructuresForm);

export default WrappedInfrastructuresForm;


// WEBPACK FOOTER //
// ./src/components/UrbioticaInfrastructuresForm.js